// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__22cZJ","empty":"ModalGraph_empty__1Aj-C"};